var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroContainers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6877 14.2169C20.0781 13.3289 21 11.7721 21 10C21 7.23858 18.7614 5 16 5C13.2386 5 11 7.23858 11 10C11 11.8325 11.9858 13.4348 13.4561 14.3054L10.916 17.3802C10.3259 17.1352 9.67873 17 9 17C6.23858 17 4 19.2386 4 22C4 24.7614 6.23858 27 9 27C11.7614 27 14 24.7614 14 22C14 20.4611 13.3048 19.0846 12.2113 18.1674L14.9238 14.8839C15.2705 14.9599 15.6306 15 16 15C16.4384 15 16.8636 14.9436 17.2687 14.8376L19.841 18.1242C18.7174 19.041 18 20.4367 18 22C18 24.7614 20.2386 27 23 27C25.7614 27 28 24.7614 28 22C28 19.2386 25.7614 17 23 17C22.3443 17 21.7181 17.1262 21.1443 17.3557L18.6877 14.2169Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroContainers);
export default __webpack_public_path__ + "static/media/hero-containers.d5474ae8af4c5ac1c24a4ae8837ab939.svg";
export { ForwardRef as ReactComponent };